/* TrendyzTech storefront interactions — Shopify Ajax API */
(function () {
  "use strict";

  var CFG = window.TRENDYZTECH || { routes: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- products data (rendered by the shop section) ---------- */
  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function safeImage(value) {
    var url = String(value || "");
    return /^(https?:)?\/\//i.test(url) || url.charAt(0) === "/" ? escapeHtml(url) : "";
  }
  var PRODUCTS = [];
  // Each product is described by Shopify Liquid on the card itself, so
  // Quick View works on home, collection, and search without guessing URLs.
  document.querySelectorAll("[data-tt-product-json]").forEach(function (el) {
    try {
      var product = JSON.parse(el.textContent);
      if (product && product.id && product.variants && product.variants.length) PRODUCTS.push(product);
    } catch (error) { /* A malformed card does not break the rest of the page. */ }
  });
  // Compatibility with older saved sections that include the previous bulk payload.
  var dataEl = document.getElementById("trendyztech-products");
  if (dataEl) { try { PRODUCTS = PRODUCTS.concat(JSON.parse(dataEl.textContent) || []); } catch (e) { /* no-op */ } }
  function productById(id) {
    for (var i = 0; i < PRODUCTS.length; i++) { if (PRODUCTS[i].id === id) return PRODUCTS[i]; }
    return null;
  }

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = CFG.moneyFormat || "Rs. {{amount}}";
    var value = (cents || 0) / 100;
    function group(num, decimals, sep, dec) {
      var parts = Math.abs(num).toFixed(decimals).split(".");
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return whole + (parts[1] ? dec + parts[1] : "");
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case "amount": return group(value, 2, ",", ".");
        case "amount_no_decimals": return group(value, 0, ",", ".");
        case "amount_with_comma_separator": return group(value, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return group(value, 0, ".", ",");
        case "amount_with_apostrophe_separator": return group(value, 2, "'", ".");
        case "amount_no_decimals_with_space_separator": return group(value, 0, " ", ".");
        case "amount_with_space_separator": return group(value, 2, " ", ",");
        default: return group(value, 2, ",", ".");
      }
    });
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function showToast(message) {
    var t = $("#toast");
    if (!t) return;
    t.textContent = message;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2200);
  }
  window.showToast = showToast;

  /* ---------- cart ---------- */
  var CART = null;

  function renderCart() {
    var countEl = $("#cartCount");
    var totalEl = $("#cartTotal");
    var body = $("#cartBody");
    if (!CART) return;
    if (countEl) countEl.textContent = CART.item_count;
    if (totalEl) totalEl.textContent = formatMoney(CART.total_price);
    if (!body) return;
    if (!CART.items || !CART.items.length) {
      body.innerHTML = '<div class="empty-cart"><div><div style="font-size:40px;margin-bottom:10px">&#128717;</div><strong>Your cart is empty</strong><p>Add a product to get started.</p></div></div>';
      return;
    }
    body.innerHTML = CART.items.map(function (item) {
      var img = safeImage(item.image);
      var variant = item.variant_title && item.variant_title !== "Default Title" ? "<small>" + escapeHtml(item.variant_title) + "</small><br>" : "";
      return '<div class="cart-item">' +
        '<img src="' + img + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" width="80" height="80">' +
        "<div><h3>" + escapeHtml(item.product_title) + "</h3>" + variant +
        "<small>" + formatMoney(item.final_price) + "</small>" +
        '<div class="cart-qty"><button type="button" data-cart-minus="' + item.key + '">&minus;</button>' +
        "<span>" + item.quantity + "</span>" +
        '<button type="button" data-cart-plus="' + item.key + '">+</button></div></div>' +
        '<button class="remove" data-remove="' + item.key + '">Remove</button></div>';
    }).join("");
  }

  function fetchCart() {
    return fetch(CFG.routes.cart + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { CART = c; renderCart(); return c; })
      .catch(function () {});
  }

  function addToCart(variantId, quantity) {
    if (!variantId) { showToast("This item is unavailable"); return Promise.resolve(false); }
    return fetch(CFG.routes.cartAdd + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { showToast(res.data.description || "Could not add to cart"); return false; }
        return fetchCart().then(function () { showToast("Added to your cart"); return true; });
      }).catch(function () { showToast("Could not add to cart"); return false; });
  }
  window.trendyztechAddToCart = addToCart;

  function changeLine(key, quantity) {
    return fetch(CFG.routes.cartChange + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { if (!r.ok) throw new Error("Cart could not be updated"); return r.json(); })
      .then(function (c) { CART = c; renderCart(); }).catch(function () { showToast("Could not update cart. Please try again."); });
  }

  function openCart() { var o = $("#cartOverlay"); if (!o) return; if (!CART) fetchCart(); o.classList.add("open"); document.body.classList.add("no-scroll"); var b=$("#closeCart");if(b)b.focus(); }
  function closeCart() { var o = $("#cartOverlay"); if (!o) return; o.classList.remove("open"); document.body.classList.remove("no-scroll"); }
  window.trendyztechOpenCart = openCart;

  document.addEventListener("click", function (e) {
    var t;
    if (e.target.closest("#cartBtn")) { e.preventDefault(); openCart(); return; }
    if (e.target.closest("#closeCart")) { closeCart(); return; }
    if ((t = e.target.closest("[data-remove]"))) { changeLine(t.getAttribute("data-remove"), 0).then(function () { showToast("Removed from cart"); }); return; }
    if ((t = e.target.closest("[data-cart-minus]"))) {
      var km = t.getAttribute("data-cart-minus");
      var im = CART && CART.items.filter(function (i) { return i.key === km; })[0];
      if (im) changeLine(km, Math.max(0, im.quantity - 1));
      return;
    }
    if ((t = e.target.closest("[data-cart-plus]"))) {
      var kp = t.getAttribute("data-cart-plus");
      var ip = CART && CART.items.filter(function (i) { return i.key === kp; })[0];
      if (ip) changeLine(kp, ip.quantity + 1);
      return;
    }
    if (e.target.closest("#checkoutBtn")) {
      if (!CART || !CART.item_count) { showToast("Your cart is empty"); return; }
      window.location.href = "/checkout";
      return;
    }
  });

  var cartOverlay = $("#cartOverlay");
  if (cartOverlay) cartOverlay.addEventListener("click", function (e) { if (e.target === cartOverlay) closeCart(); });

  /* ---------- product grid filters ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-filter]");
    if (!btn) return;
    var value = btn.getAttribute("data-filter");
    var scope = btn.closest(".container") || document;
    $$("[data-filter]", scope).forEach(function (b) { b.classList.toggle("active", b === btn); });
    var shown = 0;
    $$(".product-card[data-tags]", scope).forEach(function (card) {
      var tags = card.getAttribute("data-tags") || "";
      var match = value === "all" || tags.split(",").indexOf(value) > -1;
      card.classList.toggle("is-hidden", !match);
      if (match) shown++;
    });
    var empty = $(".empty-state", scope);
    if (empty) empty.style.display = shown ? "none" : "block";
  });

  document.addEventListener("click", function (e) {
    var link = e.target.closest("[data-footer-filter]");
    if (!link) return;
    e.preventDefault();
    var target = document.querySelector('[data-filter="' + link.getAttribute("data-footer-filter") + '"]');
    if (target) target.click();
    var shop = document.getElementById("shop");
    if (shop) shop.scrollIntoView({ behavior: "smooth" });
  });

  /* ---------- product quick view ---------- */
  var currentProduct = null, currentQuantity = 1, currentMedia = 0, currentVariant = null, quickViewOpener = null, quickViewBusy = false;

  function renderGallery() {
    if (!currentProduct) return;
    var thumbs = $("#galleryThumbs");
    if (!thumbs) return;
    var html = currentProduct.images.map(function (src, i) {
      return '<button type="button" class="gallery-thumb' + (i === currentMedia ? " active" : "") + '" data-media="' + i + '" aria-label="View image ' + (i + 1) + '"><img src="' + safeImage(src) + '" alt="' + escapeHtml(currentProduct.name) + ' image ' + (i + 1) + '" loading="lazy"></button>';
    }).join("");
    if (currentProduct.video) {
      var vi = currentProduct.images.length;
      html += '<button type="button" class="gallery-thumb video-thumb' + (currentMedia === vi ? " active" : "") + '" data-media="' + vi + '" aria-label="Watch video">&#9654;</button>';
    }
    thumbs.innerHTML = html;
    showMedia(currentMedia);
  }

  function showMedia(index) {
    if (!currentProduct) return;
    currentMedia = index;
    var image = $("#mainProductImage"), video = $("#mainProductVideo"), badge = $("#mediaBadge");
    if (!image || !video) return;
    video.pause();
    var imgCount = currentProduct.images.length;
    if (!imgCount && !currentProduct.video) { image.removeAttribute("src"); image.alt = currentProduct.name; if (badge) badge.textContent = "PRODUCT"; return; }
    if (index < imgCount) {
      video.style.display = "none";
      video.removeAttribute("src");
      image.style.display = "block";
      image.style.opacity = "0";
      image.src = currentProduct.images[index];
      image.alt = currentProduct.name + " image " + (index + 1);
      image.onload = function () { image.style.opacity = "1"; };
      if (badge) badge.textContent = "PHOTO " + (index + 1) + " / " + imgCount;
    } else {
      image.style.display = "none";
      video.style.display = "block";
      video.src = currentProduct.video;
      video.load();
      if (badge) badge.textContent = "PRODUCT VIDEO";
    }
    $$(".gallery-thumb", $("#productModal")).forEach(function (thumb) {
      thumb.classList.toggle("active", thumb.getAttribute("data-media") === String(index));
    });
    var active = $('#productModal .gallery-thumb[data-media="' + index + '"]');
    if (active) active.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
  }

  function setVariant(v) {
    currentVariant = v;
    var price = $("#modalPrice"), old = $("#modalOldPrice"), disc = $("#modalDiscount"), add = $("#modalAdd"), buy = $("#buyNow");
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    if (price) price.textContent = formatMoney(v.price);
    if (old) old.textContent = onSale ? formatMoney(v.compare_at_price) : "";
    if (disc) disc.textContent = onSale ? "SAVE " + Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100) + "%" : "";
    if (add) { add.disabled = !v.available; add.textContent = v.available ? "ADD TO CART" : "SOLD OUT"; }
    if (buy) buy.disabled = !v.available;
  }

  function openProduct(id) {
    var product = productById(id);
    var modal = $("#productModal");
    if (!product || !modal || !product.variants || !product.variants.length) return;
    currentProduct = product; currentQuantity = 1; currentMedia = 0;
    $("#modalCategory").textContent = product.categoryName || "";
    $("#modalName").textContent = product.name;
    var rating = $("#modalRating");
    if (rating) {
      if (product.rating && Number.parseInt(product.reviews, 10) > 0) {
        rating.innerHTML = "&#9733;&#9733;&#9733;&#9733;&#9733; <span>" + escapeHtml(product.rating) + " &middot; " + escapeHtml(product.reviews) + " reviews</span>";
        rating.hidden = false;
      } else { rating.textContent = ""; rating.hidden = true; }
    }
    $("#modalDescription").innerHTML = product.description || "";
    $("#qty").textContent = "1";
    var link = $("#modalFullLink");
    if (link) link.href = product.url;

    var picker = $("#modalVariants");
    if (picker) {
      if (product.variants.length > 1) {
        picker.innerHTML = '<label for="trendyztechVariant">' + escapeHtml(product.optionName || "Option") + '</label><select id="trendyztechVariant">' +
          product.variants.map(function (v) {
            return '<option value="' + v.id + '"' + (v.available ? "" : " disabled") + ">" + escapeHtml(v.title) + (v.available ? "" : " — sold out") + "</option>";
          }).join("") + "</select>";
        picker.style.display = "block";
      } else { picker.innerHTML = ""; picker.style.display = "none"; }
    }
    var first = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    if (first) setVariant(first);
    var sel = $("#trendyztechVariant");
    if (sel) sel.value = first.id;

    renderGallery();
    modal.classList.add("open");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("no-scroll");
    quickViewOpener = document.activeElement;
    var closeBtn = $("#closeProduct"); if (closeBtn) closeBtn.focus();
    if (history.replaceState) history.replaceState(null, "", "#product-" + product.id);
  }

  function closeProduct() {
    var modal = $("#productModal");
    if (!modal) return;
    var video = $("#mainProductVideo");
    if (video) { video.pause(); video.removeAttribute("src"); video.load(); }
    modal.classList.remove("open");
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("no-scroll");
    if (quickViewOpener && quickViewOpener.focus) quickViewOpener.focus();
    if (history.replaceState && location.hash.indexOf("#product-") === 0) {
      history.replaceState(null, "", location.pathname + location.search);
    }
  }

  document.addEventListener("change", function (e) {
    if (e.target && e.target.id === "trendyztechVariant" && currentProduct) {
      var v = currentProduct.variants.filter(function (x) { return String(x.id) === e.target.value; })[0];
      if (v) setVariant(v);
    }
  });

  document.addEventListener("click", function (e) {
    var t;
    if ((t = e.target.closest("[data-buy], [data-add]"))) {
      e.preventDefault(); e.stopPropagation();
      if (t.disabled || t.dataset.busy === "1") return;
      var buying = t.hasAttribute("data-buy");
      // A card must not silently purchase an arbitrary option on multi-variant products.
      if (t.getAttribute("data-needs-selection") === "true") {
        var handle = t.getAttribute(buying ? "data-buy" : "data-add");
        if (productById(handle)) {
          openProduct(handle);
          showToast("Choose your preferred option to continue");
        } else {
          var productUrl = t.getAttribute("data-product-url");
          if (productUrl) window.location.assign(productUrl);
          else showToast("Product options are temporarily unavailable");
        }
        return;
      }
      t.dataset.busy = "1";
      t.disabled = true;
      t.setAttribute("aria-busy", "true");
      addToCart(Number(t.getAttribute("data-vid")), 1)
        .then(function (ok) {
          if (!ok) return;
          if (buying) window.location.assign("/checkout");
          else openCart();
        })
        .finally(function () {
          delete t.dataset.busy;
          t.removeAttribute("aria-busy");
          t.disabled = false;
        });
      return;
    }
    if ((t = e.target.closest("[data-media]"))) { showMedia(Number(t.getAttribute("data-media"))); return; }
    if (e.target.closest("#closeProduct")) { closeProduct(); return; }
    if (e.target.closest("#qtyMinus")) { currentQuantity = Math.max(1, currentQuantity - 1); $("#qty").textContent = currentQuantity; return; }
    if (e.target.closest("#qtyPlus")) { currentQuantity = Math.min(99, currentQuantity + 1); $("#qty").textContent = currentQuantity; return; }
    if (e.target.closest("#modalAdd") || e.target.closest("#buyNow")) {
      if (!currentVariant || !currentVariant.available || quickViewBusy) return;
      var buyingFromModal = !!e.target.closest("#buyNow");
      quickViewBusy = true;
      var modalAdd = $("#modalAdd"), modalBuy = $("#buyNow");
      if (modalAdd) modalAdd.disabled = true;
      if (modalBuy) modalBuy.disabled = true;
      addToCart(currentVariant.id, currentQuantity).then(function (ok) {
        if (!ok) return;
        if (buyingFromModal) window.location.assign("/checkout");
        else { closeProduct(); openCart(); }
      }).finally(function () {
        quickViewBusy = false;
        if (currentVariant) setVariant(currentVariant);
      });
      return;
    }
    if ((t = e.target.closest("[data-product]"))) {
      // Preserve Ctrl/Cmd/Shift/middle-click and the href for SEO and full PDPs.
      if ((e.button !== undefined && e.button !== 0) || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var id = t.getAttribute("data-product");
      if (!productById(id)) return; // normal link if dynamic data is unavailable
      e.preventDefault();
      openProduct(id);
    }
  });

  var productModal = $("#productModal");
  if (productModal) {
    productModal.addEventListener("click", function (e) { if (e.target === productModal) closeProduct(); });
    productModal.addEventListener("keydown", function (e) {
      if (e.key !== "Tab") return;
      var focusables = $$('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex="0"]', productModal)
        .filter(function (element) { return element.getClientRects().length > 0; });
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (productModal && productModal.classList.contains("open")) closeProduct();
    else if (cartOverlay && cartOverlay.classList.contains("open")) closeCart();
    else if (searchOverlay && searchOverlay.classList.contains("open")) closeSearch();
  });

  /* ---------- product page (PDP) ---------- */
  var pdp = $("[data-pdp]");
  if (pdp) {
    var pdpImage = $("#pdpImage"), pdpVideo = $("#pdpVideo"), pdpBadge = $("#pdpBadge");
    $$("[data-pdp-media]", pdp).forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        $$("[data-pdp-media]", pdp).forEach(function (b) { b.classList.remove("active"); });
        thumb.classList.add("active");
        var src = thumb.getAttribute("data-src");
        if (thumb.getAttribute("data-type") === "video") {
          if (pdpImage) pdpImage.style.display = "none";
          pdpVideo.style.display = "block";
          pdpVideo.src = src; pdpVideo.load();
          if (pdpBadge) pdpBadge.textContent = "PRODUCT VIDEO";
        } else {
          if (pdpVideo) { pdpVideo.pause(); pdpVideo.style.display = "none"; }
          pdpImage.style.display = "block";
          pdpImage.src = src;
          if (pdpBadge) pdpBadge.textContent = "PHOTO " + (thumb.getAttribute("data-index") || "");
        }
      });
    });

    var qtyInput = $("#pdpQtyInput");
    if (qtyInput) {
      $("#pdpQtyMinus").addEventListener("click", function () {
        var v = Math.max(1, parseInt(qtyInput.value, 10) - 1); qtyInput.value = v; $("#pdpQtyValue").textContent = v;
      });
      $("#pdpQtyPlus").addEventListener("click", function () {
        var v = Math.min(99, parseInt(qtyInput.value, 10) + 1); qtyInput.value = v; $("#pdpQtyValue").textContent = v;
      });
    }

    var pdpForm = $("#pdpForm");
    if (pdpForm) {
      pdpForm.addEventListener("submit", function (e) {
        e.preventDefault();
        if (pdpForm.dataset.busy === "1") return;
        pdpForm.dataset.busy = "1";
        var buy = e.submitter && e.submitter.getAttribute("name") === "checkout";
        var addBtn = $("#pdpAdd"), buyBtn = $("#pdpBuy");
        if (addBtn) addBtn.disabled = true;
        if (buyBtn) buyBtn.disabled = true;
        addToCart(Number($("#pdpVariantId").value), Number($("#pdpQtyInput").value)).then(function (ok) {
          if (ok) {
            if (buy) window.location.href = "/checkout";
            else openCart();
          }
        }).finally(function () {
          pdpForm.dataset.busy = "0";
          var choice = $("#pdpVariant");
          var valid = !choice || choice.options[choice.selectedIndex].getAttribute("data-available") === "true";
          if (addBtn) addBtn.disabled = !valid;
          if (buyBtn) buyBtn.disabled = !valid;
        });
      });
    }

    var variantSelect = $("#pdpVariant");
    if (variantSelect) {
      variantSelect.addEventListener("change", function () {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        $("#pdpVariantId").value = variantSelect.value;
        var price = $("#pdpPrice"), old = $("#pdpOldPrice"), disc = $("#pdpDiscount"), btn = $("#pdpAdd"), buyBtn = $("#pdpBuy");
        var available = opt.getAttribute("data-available") === "true";
        if (price) price.textContent = opt.getAttribute("data-price");
        if (old) old.textContent = opt.getAttribute("data-compare") || "";
        if (disc) disc.textContent = opt.getAttribute("data-discount") || "";
        if (btn) { btn.disabled = !available; btn.textContent = available ? "ADD TO CART" : "SOLD OUT"; }
        if (buyBtn) buyBtn.disabled = !available;
      });
    }
  }

  /* ---------- search ---------- */
  function openSearch() { var o = $("#searchOverlay"); if (!o) return; o.classList.add("open"); document.body.classList.add("no-scroll"); setTimeout(function () { var i = $("#searchInput"); if (i) i.focus(); }, 100); }
  function closeSearch() { var o = $("#searchOverlay"); if (!o) return; o.classList.remove("open"); $("#searchInput").value = ""; $("#searchResults").innerHTML = ""; document.body.classList.remove("no-scroll"); }

  document.addEventListener("click", function (e) {
    if (e.target.closest("#searchBtn")) { e.preventDefault(); openSearch(); }
    else if (e.target.closest("#closeSearch")) closeSearch();
  });
  var searchOverlay = $("#searchOverlay");
  if (searchOverlay) searchOverlay.addEventListener("click", function (e) { if (e.target === searchOverlay) closeSearch(); });

  var searchTimer;
  var searchInput = $("#searchInput");
  if (searchInput) {
    searchInput.addEventListener("input", function (e) {
      var q = e.target.value.trim();
      var out = $("#searchResults");
      clearTimeout(searchTimer);
      if (!q) { out.innerHTML = ""; return; }
      searchTimer = setTimeout(function () {
        var url = CFG.routes.predictive + ".json?q=" + encodeURIComponent(q) +
          "&resources[type]=product&resources[limit]=8";
        fetch(url, { headers: { Accept: "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (searchInput.value.trim() !== q) return;
            var items = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!items.length) { out.innerHTML = '<p style="color:#777;padding:20px 0;font-size:13px">No products found.</p>'; return; }
            out.innerHTML = items.map(function (p) {
              var img = (p.featured_image && p.featured_image.url) || p.image || "";
              var cents = typeof p.price === "number" ? p.price : Math.round(parseFloat(p.price || 0) * 100);
              return '<a class="search-result" href="' + escapeHtml(p.url) + '"><img src="' + safeImage(img) + '" alt="' + escapeHtml(p.title) + '" loading="lazy"><div><strong>' + escapeHtml(p.title) + "</strong><small>" + formatMoney(cents) + "</small></div></a>";
            }).join("");
          })
          .catch(function () { out.innerHTML = '<p style="color:#777;padding:20px 0;font-size:13px">Search unavailable.</p>'; });
      }, 220);
    });
  }

  /* ---------- mobile nav ---------- */
  var menuBtn = $("#menuBtn");
  if (menuBtn) menuBtn.addEventListener("click", function () { var n = $("#mobileNav"); if (n) { n.classList.toggle("open"); menuBtn.setAttribute("aria-expanded", n.classList.contains("open") ? "true" : "false"); } });
  $$(".mobile-nav a").forEach(function (link) { link.addEventListener("click", function () { $("#mobileNav").classList.remove("open"); if (menuBtn) menuBtn.setAttribute("aria-expanded", "false"); }); });

  /* ---------- FAQ ---------- */
  $$(".faq-question").forEach(function (button) {
    button.addEventListener("click", function () {
      var item = button.closest(".faq-item");
      var isOpen = item.classList.contains("open");
      $$(".faq-item").forEach(function (i) {
        i.classList.remove("open");
        var p = i.querySelector(".faq-plus"); if (p) p.textContent = "+";
      });
      if (!isOpen) {
        item.classList.add("open");
        var plus = button.querySelector(".faq-plus"); if (plus) plus.textContent = "−";
      }
    });
  });

  /* ---------- UGC autoplay ---------- */
  if ("IntersectionObserver" in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target.querySelector("video");
        if (!video) return;
        if (entry.isIntersecting) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
        else video.pause();
      });
    }, { threshold: 0.4 });
    $$(".ugc-card").forEach(function (card) { observer.observe(card); });
  }

  /* ---------- keyboard ---------- */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Tab") {
      var activeDialog = $("#productModal.open");
      if (activeDialog) {
        var controls = $$("button:not([disabled]),a[href],input:not([disabled]),select:not([disabled])",activeDialog)
          .filter(function (el) { return !el.hidden && el.getClientRects().length; });
        if (controls.length) {
          var first = controls[0], last = controls[controls.length-1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      }
    }
    if (e.key !== "Escape") return;
    var m = $("#productModal"), c = $("#cartOverlay"), s = $("#searchOverlay");
    if (m && m.classList.contains("open")) { closeProduct(); return; }
    if (c && c.classList.contains("open")) { closeCart(); return; }
    if (s && s.classList.contains("open")) { closeSearch(); return; }
    var nav = $("#mobileNav"); if (nav) nav.classList.remove("open");
  });

  /* ---------- deep link ---------- */
  function openProductFromHash() {
    if (location.hash.indexOf("#product-") !== 0) return;
    var id = location.hash.replace("#product-", "");
    if (productById(id)) openProduct(id);
  }
  window.addEventListener("hashchange", openProductFromHash);

  /* ---------- init ---------- */
  var year = $("#year"); if (year) year.textContent = new Date().getFullYear();
  openProductFromHash();
})();